import Moment from 'moment';
import * as LocalStorage from './localStorageHelper';
import { productGAMapper} from './gtagHelper';

export const ATTRIBUTE_CART_STORE = "cart_data";
export const ATTRIBUTE_DELIVERY_NOTES = 'delivery_note';
export const ATTRIBUTE_DELIVERY_SLOT = 'delivery_slot';
export const ATTRIBUTE_PROMO_CODE = 'discount';
export const ATTRIBUTE_DELIVERY_TIME = 'delivery_time_interval';
export const ATTRIBUTE_DELIVERY_DATE = 'delivery_date';
export const ATTRIBUTE_CART_ITEM = 'cart_item';
export const ATTRIBUTE_CART_ITEMS = 'cart_items';
export const ATTRIBUTE_TIP_CHOICE = 'tip_choice';
export const ATTRIBUTE_TIP_PERCENT = 'tip_percent';
export const ATTRIBUTE_TIP_CHOICES = 'tip_options';
export const ATTRIBUTE_CUSTOM_TIP_AMOUNT = 'custom_tip_amount';
export const ATTRIBUTE_PAYMENT_METHOD_ID = 'payment_method_id';
export const ATTRIBUTE_BILLING_ADDRESS = 'billing_address';
export const ATTRIBUTE_DELIVERY_ADDRESS = "delivery_address";
export const ATTRIBUTE_DELIVERY_VALIDATION_STATUS = "delivery_validation_status";
export const ATTRIBUTE_IS_SAME_AS_DELIVERY_ADDRESS = "same_as_delivery_address";
export const ATTRIBUTE_GIFT_DELIVERY_DETAILS = "gift_delivery_details";
export const ATTRIBUTE_GIFT_DELIVERY = "gift_delivery";

const defaultTipChoice = 'percent_15';
const defaultTipPercent = 10; //default 10%
const persistedProps = [ATTRIBUTE_DELIVERY_NOTES, ATTRIBUTE_IS_SAME_AS_DELIVERY_ADDRESS];
const tipOptions = {
  percent_10: {
    label: '10%',
    value: 10
  },
  percent_15: {
    label: '15%',
    value: 15
  },
  percent_20: {
    label: '20%',
    value: 20
  },
  no_tip: {
    label: 'No tip',
    value: 0
  },
  custom: {
    label: 'Custom'
  },
}

const defaultCart = {
  same_as_delivery_address: true
}

export function getCartAttribute(attribute, data) {

  let cart = _getCart();
  let cartItems = _getCartItems();

  switch (attribute) {

    case ATTRIBUTE_CART_STORE:
      return cart;

    case ATTRIBUTE_CART_ITEM:
      if (data.id in cartItems)
        return cartItems[data.id];
      else
        return {};

    case ATTRIBUTE_CART_ITEMS:
      return cartItems;

    case ATTRIBUTE_DELIVERY_NOTES:
      return cart[ATTRIBUTE_DELIVERY_NOTES]

    case ATTRIBUTE_DELIVERY_SLOT:
      return cart[ATTRIBUTE_DELIVERY_SLOT];

    case ATTRIBUTE_DELIVERY_TIME:
      var deliveryTimeInterval = cart[ATTRIBUTE_DELIVERY_TIME];
      if (deliveryTimeInterval) {
        if (deliveryTimeInterval.start & deliveryTimeInterval.start !== 'now')
          deliveryTimeInterval.start = Moment(deliveryTimeInterval.start).utc().format();
        if (deliveryTimeInterval.end)
          deliveryTimeInterval.end = Moment(deliveryTimeInterval.end).utc().format();
        }
      else {
        deliveryTimeInterval = {};
        deliveryTimeInterval.start = 'now';
      }
      return deliveryTimeInterval;

    case ATTRIBUTE_DELIVERY_DATE:
      return cart[ATTRIBUTE_DELIVERY_DATE];

    case ATTRIBUTE_PROMO_CODE:
      return cart[ATTRIBUTE_PROMO_CODE];

    case ATTRIBUTE_DELIVERY_ADDRESS:
      return cart[ATTRIBUTE_DELIVERY_ADDRESS];

    case ATTRIBUTE_DELIVERY_VALIDATION_STATUS:
      return cart[ATTRIBUTE_DELIVERY_VALIDATION_STATUS];

    case ATTRIBUTE_PAYMENT_METHOD_ID:
      return cart[ATTRIBUTE_PAYMENT_METHOD_ID];

    case ATTRIBUTE_CUSTOM_TIP_AMOUNT:
      return cart[ATTRIBUTE_CUSTOM_TIP_AMOUNT];

    case ATTRIBUTE_TIP_PERCENT:
      let tipPercent = cart[ATTRIBUTE_TIP_PERCENT];
      return (tipPercent || tipPercent == 0)
        ? tipPercent
        : defaultTipPercent;

    case ATTRIBUTE_TIP_CHOICE:
      let tipChoice = cart[ATTRIBUTE_TIP_CHOICE];
      return tipChoice
        ? tipChoice
        : defaultTipChoice;

    case ATTRIBUTE_TIP_CHOICES:
      return tipOptions;

    case ATTRIBUTE_BILLING_ADDRESS:
      return cart[ATTRIBUTE_BILLING_ADDRESS];

    case ATTRIBUTE_IS_SAME_AS_DELIVERY_ADDRESS:
      return cart[ATTRIBUTE_IS_SAME_AS_DELIVERY_ADDRESS];

    case ATTRIBUTE_GIFT_DELIVERY_DETAILS:
      return cart[ATTRIBUTE_GIFT_DELIVERY_DETAILS];
    
    case ATTRIBUTE_GIFT_DELIVERY:
      return cart[ATTRIBUTE_GIFT_DELIVERY];
  }
}

export function modifyCartAttribute(attribute, data = {}) {
  let cart = _getCart();
  let cartItems = _getCartItems();

  switch (attribute) {
    case ATTRIBUTE_CART_ITEM:
      window.dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          add: {
            products: [ productGAMapper(data) ]
          }
        }
      });
      cartItems[data.id] = data.details;
      _setCartItems(cartItems);
      break;

    case ATTRIBUTE_CART_ITEMS:
      cart[ATTRIBUTE_CART_ITEMS] = data.items;
      _setCart(cart, true);
      break;

    case ATTRIBUTE_DELIVERY_NOTES:
      cart[ATTRIBUTE_DELIVERY_NOTES] = data.notes;
      _setCart(cart);
      break;
    case ATTRIBUTE_DELIVERY_SLOT:
      cart[ATTRIBUTE_DELIVERY_SLOT] = data.deliverySlot;
      _setCart(cart);
      break;

    case ATTRIBUTE_DELIVERY_TIME:
      let interval = data.interval;
      if (!interval)
        interval = {};
      else {
        if (!interval.start)
          interval.start = null;

        if (!interval.end)
          interval.end = null;
        }
      
      cart[ATTRIBUTE_DELIVERY_TIME] = interval;
      _setCart(cart);
      break;

    case ATTRIBUTE_DELIVERY_DATE:
        cart[ATTRIBUTE_DELIVERY_DATE] = data.date;
        _setCart(cart);
        break;

    case ATTRIBUTE_PROMO_CODE:
      cart[ATTRIBUTE_PROMO_CODE] = data.promoCode;
      _setCart(cart, true);
      window.dataLayer.push({
        event: 'checkoutOption',
        ecommerce: { checkout_option: { actionField: { step: 1, option: 'promoCode' } } }
      });
      break;

    case ATTRIBUTE_DELIVERY_ADDRESS:
      cart[ATTRIBUTE_DELIVERY_ADDRESS] = data.address;
      _setCart(cart, true);
      //customEvent used when address change happen
      _triggerCartAddressChangedEvent();
      window.dataLayer.push({
        event: 'checkoutOption',
        ecommerce: { checkout_option: { actionField: { step: 1, option: 'deliveryAddress' } } }
      });
      break;

    case ATTRIBUTE_DELIVERY_VALIDATION_STATUS:
      console.log("data.delivery_validation_status",data.delivery_validation_status);
      cart[ATTRIBUTE_DELIVERY_VALIDATION_STATUS] = data.delivery_validation_status;
      _setCart(cart, true);
      break;

    case ATTRIBUTE_PAYMENT_METHOD_ID:
      cart[ATTRIBUTE_PAYMENT_METHOD_ID] = data.paymentMethodId;
      _setCart(cart, true);
      window.dataLayer.push({
        event: 'checkoutOption',
        ecommerce: { checkout_option: { actionField: { step: 1, option: 'paymentMethod' } } }
      });
      break;

    case ATTRIBUTE_CUSTOM_TIP_AMOUNT:
      cart[ATTRIBUTE_CUSTOM_TIP_AMOUNT] = data.amount;
      _setCart(cart, true);
      window.dataLayer.push({
        event: 'checkoutOption',
        ecommerce: { checkout_option: { actionField: { step: 1, option: 'tipAmount' } } }
      });
      break;

    case ATTRIBUTE_TIP_CHOICE:
      cart[ATTRIBUTE_TIP_CHOICE] = data.choice;
      _setCart(cart, true);
      break;

    case ATTRIBUTE_TIP_PERCENT:
      cart[ATTRIBUTE_TIP_PERCENT] = data.tipPercent;
      _setCart(cart, true);
      break;

    case ATTRIBUTE_BILLING_ADDRESS:
      cart[ATTRIBUTE_BILLING_ADDRESS] = data.address;
      _setCart(cart);
      break;

    case ATTRIBUTE_IS_SAME_AS_DELIVERY_ADDRESS:
      cart[ATTRIBUTE_IS_SAME_AS_DELIVERY_ADDRESS] = data.value;
      _setCart(cart);
      break;
    
    case ATTRIBUTE_GIFT_DELIVERY_DETAILS:
        cart[ATTRIBUTE_GIFT_DELIVERY_DETAILS] = data.giftDeliveryDetails
        _setCart(cart);
      break;
    case ATTRIBUTE_GIFT_DELIVERY:
        cart[ATTRIBUTE_GIFT_DELIVERY] = data.giftDelivery;
        _setCart(cart);
        break;
  }
  return _getCart();
}

export function removeCartAttribute(attribute, data = {}) {
  let cart = _getCart();
  let cartItems = _getCartItems();

  switch (attribute) {
    case ATTRIBUTE_CART_ITEM:
      if (data.itemId in cartItems) {
        const product = cartItems[data.itemId];
        const { itemId: id } = data;
        window.dataLayer.push({
          event: 'removeFromCart',
          ecommerce: {
            remove: {
              products: [
                productGAMapper(product)
              ]
            }
          }
        });

        delete cartItems[data.itemId];
      }
      _setCartItems(cartItems);
      break;

    case ATTRIBUTE_CART_ITEMS:
      cart[ATTRIBUTE_CART_ITEMS] = {};
      _setCart(cart);
      break;

    case ATTRIBUTE_PROMO_CODE:
      delete cart[ATTRIBUTE_PROMO_CODE];
      _setCart(cart);
  }

  return _getCart();
}

export function calculateDiscountedSubtotal(sum, sumBundle, bundleEnabled, subTotal ,discount) {
  var discountSubTotal = 0
  var discountAmount = 0
  if (discount) {
    if (discount.discountType == 1) {
      discountAmount =  discount.discount
    }
    if (discount.discountType == 2) {
      if (bundleEnabled) {
        discountAmount = Math.floor((discount.discount * sum) * 100) / 100
      } else {
        discountAmount = Math.floor((discount.discount * subTotal) * 100) / 100
      }  
      discountAmount = Math.round(discountAmount * 100) / 100
    }
  }

  discountSubTotal = subTotal - discountAmount
  return discountSubTotal
}

export function calculateTipAmount(subTotal) {

  let tipChoice = getCartAttribute(ATTRIBUTE_TIP_PERCENT);
  let customTipAmount = getCartAttribute(ATTRIBUTE_CUSTOM_TIP_AMOUNT);
  switch (tipChoice) {
    case 10:
      return parseFloat(((subTotal * 10) / 100).toFixed(2)); // 10% of subtotal
      break;
    case 15:
      return parseFloat(((subTotal * 15) / 100).toFixed(2)); // 15% of subtotal
      break;
    case 20:
      return parseFloat(((subTotal * 20) / 100).toFixed(2)); // 20% of subtotal
      break;
    case 0:
      return 0; // no tip
      break;
    case -1:
      return customTipAmount
        ? parseFloat(customTipAmount)
        : 0; // custom tip amount, default 0
        break;
    default: 
      return customTipAmount
      ? parseFloat(customTipAmount)
      : 0;
      break;
  }
}

export function getProductsCount() {

  var cartItems = _getCartItems();
  var count = 0;
  for (var itemId in cartItems) {
    count += cartItems[itemId].quantity;
  }
  return count;
}

export function isProductExist(itemId) {
  var cartItems = _getCartItems();
  return cartItems[itemId]
}

export function clearCart() {

  let cart = _getCart();
  let persistedPropsData = {};
  persistedProps.forEach(function(dataKey) {
    persistedPropsData[dataKey] = cart[dataKey];
  });
  cart = persistedPropsData;
  LocalStorage.remove("delivery_address");
  _setCart(cart, true);
}

export function _getCartItems() {

  var cart = _getCart();
  if (typeof cart[ATTRIBUTE_CART_ITEMS] === 'undefined') {
    cart[ATTRIBUTE_CART_ITEMS] = {};
  }
  return cart[ATTRIBUTE_CART_ITEMS];
}

export function _setCartItems(items) {

  var cart = _getCart();
  cart[ATTRIBUTE_CART_ITEMS] = items;
  _setCart(cart, true);
}

export function _getCart() {
  return LocalStorage.get(ATTRIBUTE_CART_STORE)
    ? LocalStorage.get(ATTRIBUTE_CART_STORE)
    : defaultCart;
}

export function _setCart(cart, isNotify = false) {

  LocalStorage.put(ATTRIBUTE_CART_STORE, cart);
  if (isNotify)
    _triggerCartItemsChangedEvent();
  }

function _triggerCartItemsChangedEvent() {
  const event = new CustomEvent('cart_changed', {detail: _getCart()});
  window.dispatchEvent(event);
  console.log('cart_changed event dispached', event);
}

function _triggerCartAddressChangedEvent() {
  const event = new CustomEvent('address_changed', {detail: _getCart()});
  window.dispatchEvent(event);
  console.log('address_changed event dispached', event);
}



// WEBPACK FOOTER //
// ./src/utils/cartHelper.js